import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { formatPrecio } from '../../utils/formatters';

/**
 * Modal para actualizar el costo de productos
 */
function ModalActualizarCostos({
  show,
  onHide,
  productos,
  costoUniforme,
  onActualizar,
  updating,
  error
}) {
  const [costo, setCosto] = useState('');

  useEffect(() => {
    if (show) {
      setCosto(costoUniforme != null ? costoUniforme : '');
    }
  }, [show, costoUniforme]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onActualizar(costo);
  };

  const canSubmit = costo !== '' && costo != null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar Costos</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {costoUniforme != null && costoUniforme !== '' ? (
            <Alert variant="info" className="mb-3">
              Los productos filtrados tienen el mismo costo ({formatPrecio(costoUniforme)}). Puedes actualizarlos todos a la vez.
            </Alert>
          ) : (
            <Alert variant="warning" className="mb-3">
              Los productos filtrados tienen costos diferentes. El nuevo costo se aplicará a todos los productos seleccionados.
            </Alert>
          )}
          <p className="mb-3">
            Se actualizarán <strong>{productos.length}</strong> producto{productos.length !== 1 ? 's' : ''}.
          </p>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Costo</Form.Label>
              <Form.Control
                type="number"
                value={costo}
                onChange={(e) => setCosto(e.target.value)}
                placeholder="0"
                step="0.01"
                min="0"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={updating}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={updating || !canSubmit}
          >
            {updating ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Actualizando...
              </>
            ) : (
              'Actualizar Costos'
            )}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ModalActualizarCostos;
